import { Timeline } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  margin: 50px 0;

  .title {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    text-align: center;
    ${(props) => props.theme.typo.familyGoogle.bold}
  }

  .subtitle {
    font-size: 1.25rem;
    line-height: 25px;
    color: ${(props) => props.theme.color.lightGrey};
    ${(props) => props.theme.typo.familyGoogle.regular}
    a {
      color: #485fc7;
      &:hover {
        color: ${(props) => props.theme.color.onSurface};
      }
    }
  }
`;
const StyledDescription = styled.div`
  color: ${(props) => props.theme.textGreyColor};
  text-align: left;
`;

const StyledTimeline = styled(Timeline)`
  font-size: 14px;
  line-height: 22px;
  position: relative;
  left: -20%;

  p {
    margin: 0;
  }

  .ant-timeline-item-label {
    color: ${(props) => props.theme.color.onSurface};
    font-weight: 700;
    ${(props) => props.theme.typo.familyGoogle.bold}
  }

  .timelineDescMain {
    font-weight: 600;
    ${(props) => props.theme.typo.familyGoogle.semiBold}
    color: ${(props) => props.theme.color.onSurface};

    span {
      color: ${(props) => props.theme.color.lightOrange};
    }
  }

  .timelineDescSub {
    color: ${(props) => props.theme.color.onSurface};
    ${(props) => props.theme.typo.familyGoogle.regular}
  }

  .dot {
    background-color: ${(props) => props.theme.color.lightOrange};
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
`;

interface Props {
  title: string | ReactNode;
  description?: string | ReactNode;
  type: 'paragraph' | 'timeline';
  timelineContent?: {
    time: string | ReactNode;
    descMain: string | ReactNode;
    descSub: string | ReactNode;
  }[];
}

export const DescriptionParagraph: FC<Props> = ({ title, description, type, timelineContent }) => (
  <StyledWrapper>
    <h2 className="title">{title}</h2>
    {type === 'paragraph' ? (
      <StyledDescription className="subtitle is-spaced is-5">{description}</StyledDescription>
    ) : (
      <StyledTimeline mode="left">
        {timelineContent?.map((timelineNode, index) => (
          <Timeline.Item key={index} label={timelineNode.time} dot={timelineNode.time ? null : <div className="dot" />}>
            {timelineNode.descMain && <p className="timelineDescMain">{timelineNode.descMain}</p>}
            {timelineNode.descSub && <p className="timelineDescSub">{timelineNode.descSub}</p>}
          </Timeline.Item>
        ))}
      </StyledTimeline>
    )}
  </StyledWrapper>
);

export default DescriptionParagraph;
